function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M34.194 17.734a2 2 0 010 2.828l-11.08 11.08a2 2 0 01-2.838.429 2.127 2.127 0 01-.224-.195l-.068-.074-5.568-5.566a2 2 0 112.829-2.828l4.223 4.222 9.897-9.896a2 2 0 012.829 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgHuge = function SvgHuge(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 48,
      height: 48
    }, props), _ref)
  );
};

export default SvgHuge;